import { sessionSave as save, sessionLoad as load } from 'Core/Utils/Session';
import AuthInitialState from 'RLX/State/Auth/AuthInitialState';

const AuthReducer = (state = AuthInitialState, { type, payload } = {}) => {
  switch (type) {
    case 'auth/REQUEST_STARTED': {
      const loading = true;
      const errorMessage = null;
      return {
        ...state,
        loading,
        errorMessage
      };
    }

    case 'auth/REQUEST_COMPLETED': {
      const loading = false;
      const errorMessage = null;
      return {
        ...state,
        errorMessage,
        loading
      };
    }

    case 'auth/LOGGED_OUT': {
      const loggedIn = false;
      const user = null;
      save('loggedIn', loggedIn);
      return {
        ...state,
        loggedIn,
        user
      };
    }

    case 'auth/STATUS_RECEIVED': {
      const { user } = payload;
      const loggedIn = !!(user && user.email);
      save('loggedIn', loggedIn);
      return {
        ...state,
        user,
        loggedIn
      };
    }

    case 'auth/ERROR': {
      const loading = false;
      const { errorMessage } = payload;
      return {
        ...state,
        loading,
        errorMessage
      };
    }

    default:
      return state;
  }
};

export default AuthReducer;



// WEBPACK FOOTER //
// ./client/RLX/State/Auth/AuthReducer.js